const TOUR_STYLES = {
  backgroundColor: 'rgb(249 250 251)',
  borderRadius: '12px',
  color: 'rgb(55 65 81)',
};

export const MATTERS_LIST_TOUR_STEPS = [
  {
    selector: '[data-tour="create-matter-btn"]',
    content: 'Create a new Matter to begin uploading documents.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="matters-list"]',
    content: 'All your Matters live here, just like in the previous version of Wexler. Click on a Matter to open it.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="sidebar"]',
    content:
      'The sidebar changes based on where you are. At the root level, you see general navigation. When inside a Matter or Subset, you will see relevant options for that context.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="breadcrumb"]',
    content:
      'The header shows your current position in the application. Click any item to navigate back to that level.',
    style: TOUR_STYLES,
  },
];

export const MATTER_OVERVIEW_TOUR_STEPS = [
  {
    selector: '[data-tour="matter-stats"]',
    content: 'View key statistics for your matter including facts, inconsistencies, documents, and entities.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="create-subset-btn"]',
    content: 'Create a new subset to focus your analysis on a specific collection of documents.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="add-documents-btn"]',
    content: 'Upload additional documents to your matter.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="recent-subsets"]',
    content: 'Quick access to your recently viewed or created subsets.',
    style: TOUR_STYLES,
  },
];

export const SUBSETS_LIST_TOUR_STEPS = [
  {
    selector: '[data-tour="create-subset-btn"]',
    content: 'Create a new subset to organise and filter your documents for focused analysis.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="subsets-table"]',
    content: 'View all your subsets here. Click on a row to open that subset. Any of your old cases will appear here.',
    style: TOUR_STYLES,
  },
];

export const SUBSET_CREATION_TOUR_STEPS = [
  {
    selector: '[data-tour="subset-form"]',
    content:
      'Give your Subset a name and specify the legal issues to determine how facts are classified for relevance.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="doc-picker-table"]',
    content: 'Select the documents you want to include in this Subset.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="doc-filters"]',
    content: 'Use the search and filters to narrow down documents by type, extension, date, entities, and more.',
    style: TOUR_STYLES,
  },
  {
    selector: '[data-tour="show-selected-toggle"]',
    content: 'Toggle this to view only the documents you have already selected for this Subset.',
    style: TOUR_STYLES,
  },
];
